/* Naguirre — ajustes da gaveta do carrinho (03/10/2026).
   1) O "Voltar" do celular/navegador fecha a gaveta em vez de tirar a cliente da página.
      Medido em 02/10: abrir a gaveta não criava entrada no histórico, então o Voltar do
      Android (e a seta do navegador do Instagram) levava a cliente para fora do produto.
   2) 05/10/2026 (A02): na página /cart, o painel de cupom do tema (o mesmo da gaveta, window.NaguirreCupom)
      no lugar da caixa do app dcart; saiu o renomeador de chips do dcart (a linha "Desconto:" agora mostra
      "Promoção aplicada" pelo Liquid). */
(function () {
  'use strict';

  var body = document.body;
  if (!body) return;

  // ---------- 1) Voltar fecha a gaveta ----------
  var CLASSE_ABERTA = 'cart-sidebar-show';
  var CHAVE = 'ngGaveta';
  var empurrou = false;
  var hrefDoPush = null;

  function aberta() {
    return body.classList.contains(CLASSE_ABERTA);
  }

  function nossaEntrada() {
    return !!(history.state && typeof history.state === 'object' && history.state[CHAVE]);
  }

  function fecharGaveta() {
    // Fecha tirando a classe, exatamente como o handler do X do tema faz. NÃO usar
    // botao.click(): clique sintético vira "clique" para os rastreadores (o automático
    // da Meta registrou SubscribedButtonClick nesse caso no teste de 03/10).
    body.classList.remove(CLASSE_ABERTA);
  }

  if (window.history && typeof history.pushState === 'function') {
    // Entrada órfã: a página recarregou (ou voltou do checkout) já em cima da entrada que a
    // gaveta criou, com a gaveta fechada. Sem isto, o 1º Voltar da cliente "não faz nada".
    if (nossaEntrada() && !aberta()) {
      try { history.back(); } catch (e) {}
    }

    new MutationObserver(function () {
      if (aberta() && !empurrou) {
        // Preserva o estado que já existia (ex.: filtros da coleção leem state.searchParams).
        var base = (history.state && typeof history.state === 'object') ? history.state : {};
        var estado = {};
        for (var k in base) {
          if (Object.prototype.hasOwnProperty.call(base, k)) estado[k] = base[k];
        }
        if (!('searchParams' in estado)) estado.searchParams = location.search.slice(1);
        estado[CHAVE] = true;
        try {
          history.pushState(estado, '');
          empurrou = true;
          hrefDoPush = location.href;
        } catch (e) {}
      } else if (!aberta() && empurrou) {
        // Fechou pelo X, pelo fundo ou pelo "Continuar": tira a entrada que criamos, mas só se a
        // URL ainda for a do push. Se algo trocou a URL com a gaveta aberta (ex.: ?variant=), voltar
        // mudaria a URL e a Meta e o GA4 contariam uma página a mais.
        empurrou = false;
        if (location.href === hrefDoPush) {
          try { history.back(); } catch (e) {}
        }
      }
    }).observe(body, { attributes: true, attributeFilter: ['class'] });

    window.addEventListener('popstate', function () {
      // Fecha só quando o Voltar saiu da nossa entrada (e não num popstate qualquer).
      if (empurrou && aberta() && !nossaEntrada()) {
        empurrou = false;
        fecharGaveta();
      }
    });
  }

  // ---------- 2) Cupom na página /cart: o mesmo painel e a mesma lógica da gaveta ----------
  // Redesenho pelo próprio tema (window.ngRedesenharCarrinhoPagina → T.updateCart, que troca itens, totais e o
  // painel e avisa "cart-update"); nunca window.updateCart() nem window.refreshCart(), que abrem a gaveta.
  // Os apps que mudam o carrinho sozinhos (Discount On Cart Pro e o colar do Dr Free Gift) avisam por eventos
  // em document.body (não borbulham): cada um só agenda a leitura de sempre, que compara a assinatura do Liquid
  // com o /cart.js e, se a página ficou velha, pede o redesenho (no máximo 6 por minuto, nunca a mesma
  // diferença 2 vezes). Enquanto um redesenho nosso está a caminho (até o "cart-update", no máximo 3 s), os
  // eventos são ignorados. O que a cliente digita no campo sobrevive ao redesenho. Depois de aplicar ou remover,
  // o foco fica no painel novo: no campo, pelo teclado; no "Aplicar", por toque (decisão 5, 05/10/2026).
  function iniciarCupomDaPagina() {
    var raiz = document.getElementById('main-cart-items');
    if (!raiz || !raiz.querySelector('#ng-cupom-pagina')) return;
    var AVISO = '<p class="ng-cupom__aviso">Para usar um cupom, digite o código no pagamento.</p>';
    if (!window.NaguirreCupom || typeof window.NaguirreCupom.montar !== 'function') {
      // Gaveta desligada no editor ou JS que não carregou: o campo vira o aviso (o tema troca o li a cada redesenho).
      var semCupom = function () { var li = raiz.querySelector('#ng-cupom-pagina'); if (li) li.innerHTML = AVISO; };
      semCupom();
      document.addEventListener('cart-update', semCupom);
      return;
    }
    var pendente = 0;     // hora do redesenho nosso a caminho (0 = nenhum)
    var digitado = null;  // { valor, ini, fim } do campo, até o aplicar ou o remover terminarem
    var CAMPO = '[data-ng-cupom]', APLICAR = '[data-ng-aplicar]';
    var focoNoPainel = ''; // o controle do painel (CAMPO ou APLICAR) que tinha o foco quando o redesenho saiu
    // Correção 1 (CUPC-14): ação pelo TECLADO no painel (Enter no campo; Enter ou Espaço no "Aplicar" ou no
    // "Remover"). O "Aplicar" fica desligado durante o pedido, e o navegador manda o foco ao <body>: no fim, o foco
    // volta ao campo. Só pelo teclado: depois de um toque, focar o campo reabriria o teclado do celular.
    // Decisão 5 (05/10/2026, CUPC-14): por toque, mouse ou leitor de tela, o foco vai ao "Aplicar" (o do painel
    // novo, depois do redesenho). O teclado do celular não abre e o leitor de tela não perde o lugar. Vale também
    // para o "Remover", que some com o cupom.
    var porTeclado = false;
    function painelDaPagina() { return raiz.querySelector('#ng-cupom-pagina'); }
    function focarNoPainel(seletor) {
      var alvo = seletor && raiz.querySelector('#ng-cupom-pagina ' + seletor);
      if (alvo) { try { alvo.focus({ preventScroll: true }); } catch (e) {} }
    }
    raiz.addEventListener('keydown', function (ev) {
      var li = painelDaPagina();
      if ((ev.key === 'Enter' || ev.key === ' ') && li && li.contains(ev.target)) porTeclado = true;
    }, true);
    raiz.addEventListener('click', function (ev) { if (ev.detail > 0) porTeclado = false; }, true); // toque ou mouse
    var painel = window.NaguirreCupom.montar(raiz, {
      redesenhar: function (carrinho) {
        pendente = Date.now();
        var li = painelDaPagina();
        var ativo = document.activeElement;
        // O redesenho troca o painel inteiro: o foco volta ao mesmo controle no painel novo ("Aplicar" ao
        // "Aplicar"; o campo ou um "Remover", ao campo).
        focoNoPainel = li && ativo && li.contains(ativo) ? (ativo.matches && ativo.matches(APLICAR) ? APLICAR : CAMPO) : '';
        if (typeof window.ngRedesenharCarrinhoPagina === 'function') window.ngRedesenharCarrinhoPagina(carrinho);
        else window.location.reload();
      },
      lembrarMensagem: true,
      lugar: 'carrinho', // medição (leva E): os eventos do cupom deste painel saem com lugar "carrinho"
      regiaoViva: '#cart-live-region-text',
      terminou: function () {
        digitado = null;
        // Antes do redesenho: com o foco de volta no painel, o redesenho o devolve ao controle novo. Sem redesenho
        // (M3, M10, M12), o foco fica onde foi posto aqui.
        var alvo = porTeclado ? CAMPO : APLICAR;
        porTeclado = false;
        focarNoPainel(alvo);
      }
    });
    raiz.addEventListener('input', function (ev) {
      var c = ev.target;
      if (!c.matches || !c.matches('#ng-cupom-pagina [data-ng-cupom]')) return;
      digitado = c.value ? { valor: c.value, ini: c.selectionStart, fim: c.selectionEnd } : null;
    });
    document.addEventListener('cart-update', function () {
      pendente = 0;
      var campo = raiz.querySelector('#ng-cupom-pagina ' + CAMPO);
      if (campo && digitado && !campo.value) {
        // O redesenho trocou o campo no meio da digitação (ex.: o DOCP reaplicou um cupom no 1º toque).
        campo.value = digitado.valor;
        try { campo.focus({ preventScroll: true }); campo.setSelectionRange(digitado.ini, digitado.fim); } catch (e) {}
      } else {
        focarNoPainel(focoNoPainel); // o foco estava no painel: volta ao mesmo controle no painel novo
      }
      focoNoPainel = '';
      setTimeout(painel.depoisDoRedesenho, 0);
    });
    ['docapp-cart-change', 'docapp-applied-discount-code-changed', 'docapp-discount-applied'].forEach(function (nome) {
      document.body.addEventListener(nome, function () {
        if (!pendente || Date.now() - pendente > 3000) painel.depoisDoRedesenho();
      });
    });
    painel.depoisDoRedesenho(); // 1ª leitura: mostra o cupom de frete e o que o DOCP tiver reaplicado
  }
  // Este arquivo roda antes do naguirre-gaveta.js (os dois com defer): espera o DOMContentLoaded.
  var iniciado = false;
  function iniciarUmaVez() { if (iniciado) return; iniciado = true; iniciarCupomDaPagina(); }
  if (document.readyState === 'complete') iniciarUmaVez();
  else {
    document.addEventListener('DOMContentLoaded', iniciarUmaVez);
    window.addEventListener('load', iniciarUmaVez);
  }
})();
